export default __webpack_public_path__ + "static/album-47744b06e1b2f673808e5c68a5373432.png";